// extracted by mini-css-extract-plugin
export default {"title":"Ulh3u","content":"bOeux","items":"S2ehg","item":"Jhgq6","icon":"zQFTc","text":"e_r9U"};